import React from 'react';
import { useTranslation } from 'react-i18next';
import { classnames } from '../../../../utils/classnames';
import BackButton from '../backButton/backButton';
import LanguageSelector from '../../ui/language/languageSelector';
import Icon from '../../ui/icon/icon';
import Button from '../../ui/button/button';
import { logout } from '../../../../utils/logout';
import './stepHeader.css';


export default function StepHeader({config = {}, changeLanguage = () => {}, onSubmit = () => {}, isSubmitting, lang, storage, ...rest}) {
    const { t } = useTranslation();
    const _config = config.step_header;

    const _onDisconnect = React.useCallback(() => {
        const contextLogout = 'stepHeader'
        return logout(contextLogout, storage)
	}, [storage]);

    return (
        <div className={classnames('neo-rate-step-title', {'with-button': _config.previous_button})}>
            {_config.previous_button && <BackButton title={_config.previous_button.title} onSubmit={onSubmit} {...rest}/>}
            <div className='neo-step-header-language-and-disconnect'>
                {_config.available_languages?.length > 0 && (
                    <LanguageSelector
                        loading={isSubmitting}
                        onChange={(lang) => {
                            changeLanguage(null, { value: lang });
                            //TODO: forceLang because stepManager doesn't have time to update the lang before onSubmit is played
                            onSubmit({ forceLang: lang, data: { action: 'change_language' } });
                        }}
                        forceMobile={true}
                        displayIcon={false}
                        value={lang}
                        languages={_config.available_languages}
                    />
                )}
                {_config.logout_button &&
                    <Button className='neo-logout-button' type='secondary' onClick={_onDisconnect} label={
                        <>
                            <Icon name={_config.logout_button.icon} />
                            <span className='neo-logout-button-text'>{t('widget.header.disconnect')}</span>
                        </>
                    }/>
                }
            </div>
        </div>
    )
}
